const startPoints = {
  chapter_1: 20,
  chapter_2: 0,
  chapter_3: 20,
};

export default startPoints;
